import { Pipe, PipeTransform } from '@angular/core'
import { environment } from 'src/environments/environment'

@Pipe({
  name: 'appendFileDomain',
  standalone: true
})
export class AppendFileDomainPipe implements PipeTransform {
  transform(path?: string | null): string {
    return !path?.startsWith('http') ? environment.s3_files_root + path : path
  }
}
